import * as React from "react";

const SvgContentCopy = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.82 17.5V5.82H6.68V17.5h9.14Zm0-13.32c.443 0 .834.162 1.172.488.339.325.508.71.508 1.152V17.5c0 .443-.17.833-.508 1.172-.338.338-.729.508-1.172.508H6.68c-.443 0-.834-.17-1.172-.508C5.169 18.333 5 17.942 5 17.5V5.82c0-.442.17-.827.508-1.152.338-.326.729-.488 1.172-.488h9.14ZM13.32.82V2.5h-10v11.68H1.68V2.5c0-.443.162-.833.488-1.172C2.493.99 2.878.82 3.32.82h10Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgContentCopy;
